import { TabContent } from '@screens/landing-page-tools/types';

export const tabsAndContents: TabContent[] = [
  {
    tab: 'Estudo',
    icon: 'book-open-text',
    title: 'Apoio e segurança para consolidar o que foi visto durante as aulas, nos seus primeiros anos da faculdade.',
    images: {
      xs: 'lp-tools-study-xl.webp',
      sm: 'lp-tools-study-xl.webp',
      md: 'lp-tools-study-xl.webp',
      lg: 'lp-tools-study-xl.webp',
      xl: 'lp-tools-study-xl.webp',
    },
    accordions: [
      {
        title:
          'Aprenda a identificar sintomas durante a anamnese e descubra o significado de siglas e epônimos da rotina médica.',
        cards: [
          {
            id: 1,
            title: 'Semiologia',
            images: {
              xs: 'lp-tools-semiology-xl.webp',
              sm: 'lp-tools-semiology-xl.webp',
              md: 'lp-tools-semiology-xl.webp',
              lg: 'lp-tools-semiology-xl.webp',
              xl: 'lp-tools-semiology-xl.webp',
            },
            description: 'Conteúdos sobre sinais e sintomas das doenças, com foco na avaliação clínica do paciente.',
          },
          {
            id: 2,
            title: 'Glossário',
            images: {
              xs: 'lp-tools-glossary-xl.webp',
              sm: 'lp-tools-glossary-xl.webp',
              md: 'lp-tools-glossary-xl.webp',
              lg: 'lp-tools-glossary-xl.webp',
              xl: 'lp-tools-glossary-xl.webp',
            },
            description:
              'Dicionário médico com epônimos, siglas e definições essenciais para estudantes e profissionais de saúde.',
          },
        ],
      },
      {
        title: 'Siga um roteiro estruturado para diagnósticos e tratamentos, aprimorando suas habilidades clínicas',
        cards: [
          {
            id: 3,
            title: 'Decision Tracks',
            images: {
              xs: 'lp-tools-decision-tracks-xl.webp',
              sm: 'lp-tools-decision-tracks-xl.webp',
              md: 'lp-tools-decision-tracks-xl.webp',
              lg: 'lp-tools-decision-tracks-xl.webp',
              xl: 'lp-tools-decision-tracks-xl.webp',
            },
            description:
              'Fluxogramas interativos que auxiliam nas decisões de diagnóstico, estratificação de risco e tratamento, promovendo um aprendizado dinâmico sobre raciocínio clínico.',
          },
          {
            id: 4,
            title: 'Abordagens completas de doenças e patologias',
            images: {
              xs: 'lp-tools-takes-xl.webp',
              sm: 'lp-tools-takes-xl.webp',
              md: 'lp-tools-takes-xl.webp',
              lg: 'lp-tools-takes-xl.webp',
              xl: 'lp-tools-takes-xl.webp',
            },
            description: 'Guias detalhados sobre diversas condições clínicas, incluindo diagnóstico e tratamento.',
          },
        ],
      },
    ],
  },
  {
    tab: 'Internato',
    icon: 'orientacao-ao-paciente',
    title:
      'Fortaleça seu raciocínio clínico e competências médicas, para ter mais autonomia nos primeiros contatos com pacientes.',
    images: {
      xs: 'lp-tools-internship-xl.webp',
      sm: 'lp-tools-internship-xl.webp',
      md: 'lp-tools-internship-xl.webp',
      lg: 'lp-tools-internship-xl.webp',
      xl: 'lp-tools-internship-xl.webp',
    },
    accordions: [
      {
        title:
          'Consulte informações sobre cerca de 2.000 medicamentos e como prescrever o melhor tratamento em ambiente ambulatorial ou hospitalar',
        cards: [
          {
            id: 5,
            title: 'Medicamentos',
            images: {
              xs: 'lp-tools-medicines-xl.webp',
              sm: 'lp-tools-medicines-xl.webp',
              md: 'lp-tools-medicines-xl.webp',
              lg: 'lp-tools-medicines-xl.webp',
              xl: 'lp-tools-medicines-xl.webp',
            },
            description:
              'Referência rápida sobre medicamentos utilizados na prática clínica, como mecanismo de ação, posologia, ajustes de dose e efeitos adversos.',
          },
          {
            id: 6,
            title: 'Prescrição',
            images: {
              xs: 'lp-tools-prescription-xl.webp',
              sm: 'lp-tools-prescription-xl.webp',
              md: 'lp-tools-prescription-xl.webp',
              lg: 'lp-tools-prescription-xl.webp',
              xl: 'lp-tools-prescription-xl.webp',
            },
            description:
              'Suporte para prescrição nos ambientes ambulatorial ou hospitalar, garantindo mais segurança e precisão na escolha do tratamento.',
          },
        ],
      },
      {
        title:
          'Conte com imagens e descrições de exames e doenças para auxiliar na identificação de diagnósticos e na escolha do melhor tratamento',
        cards: [
          {
            id: 7,
            title: 'Atlas de Radiologia',
            images: {
              xs: 'lp-tools-atlas-xl.webp',
              sm: 'lp-tools-atlas-xl.webp',
              md: 'lp-tools-atlas-xl.webp',
              lg: 'lp-tools-atlas-xl.webp',
              xl: 'lp-tools-atlas-xl.webp',
            },
            description:
              'Guia visual com imagens e descrições detalhadas para facilitar o entendimento de exames e a identificação de lesões e patologias.',
          },
        ],
      },
    ],
  },
  {
    tab: 'Plantão',
    icon: 'calendar-plus',
    title: 'Esteja preparado para tomar decisões mais seguras durante os seus plantões médicos.',
    images: {
      xs: 'lp-tools-shift-xl.webp',
      sm: 'lp-tools-shift-xl.webp',
      md: 'lp-tools-shift-xl.webp',
      lg: 'lp-tools-shift-xl.webp',
      xl: 'lp-tools-shift-xl.webp',
    },
    accordions: [
      {
        title:
          'Consulte as principais abordagens de casos de emergência e cuidados intensivos e veja como realizar diversos procedimentos',
        cards: [
          {
            id: 8,
            title: 'Conteúdos de Emergência e UTI',
            images: {
              xs: 'lp-tools-emergency-xl.webp',
              sm: 'lp-tools-emergency-xl.webp',
              md: 'lp-tools-emergency-xl.webp',
              lg: 'lp-tools-emergency-xl.webp',
              xl: 'lp-tools-emergency-xl.webp',
            },
            description:
              'Conteúdos que te apoiam em casos de emergência e cuidados intensivos, com foco em procedimentos mais seguros e eficazes.',
          },
          {
            id: 9,
            title: 'Guia de procedimentos',
            images: {
              xs: 'lp-tools-guide-xl.webp',
              sm: 'lp-tools-guide-xl.webp',
              md: 'lp-tools-guide-xl.webp',
              lg: 'lp-tools-guide-xl.webp',
              xl: 'lp-tools-guide-xl.webp',
            },
            description:
              'Relembre indicações, materiais, preparo e cuidados e veja a vídeos práticos de como fazer procedimentos.',
          },
        ],
      },
      {
        title:
          'Acesse ferramentas que auxiliam no diagnóstico e tratamento de diferentes condições clínicas de forma rápida e segura',
        cards: [
          {
            id: 10,
            title: 'Diagnóstico Diferencial (DDX)',
            images: {
              xs: 'lp-tools-ddx-xl.webp',
              sm: 'lp-tools-ddx-xl.webp',
              md: 'lp-tools-ddx-xl.webp',
              lg: 'lp-tools-ddx-xl.webp',
              xl: 'lp-tools-ddx-xl.webp',
            },
            description:
              'Identifique de maneira rápida condições compatíveis com os sinais e sintomas do paciente, por meio da análise de hipóteses diagnósticas para investigação.',
          },
          {
            id: 11,
            title: 'Interação Medicamentosa',
            images: {
              xs: 'lp-tools-drug-interaction-xl.webp',
              sm: 'lp-tools-drug-interaction-xl.webp',
              md: 'lp-tools-drug-interaction-xl.webp',
              lg: 'lp-tools-drug-interaction-xl.webp',
              xl: 'lp-tools-drug-interaction-xl.webp',
            },
            description:
              'Consulte a gravidade da interação medicamentosa e saiba se o uso conjunto de dois fármacos pode afetar a eficácia ou causar reações indesejadas.',
          },
        ],
      },
    ],
  },
  {
    tab: 'Consultório',
    icon: 'house',
    title:
      'Conteúdos e ferramentas baseados em diretrizes médicas, voltados para o mercado brasileiro, revisados e atualizados por outros médicos especialistas.',
    images: {
      xs: 'lp-tools-clinic-xl.webp',
      sm: 'lp-tools-clinic-xl.webp',
      md: 'lp-tools-clinic-xl.webp',
      lg: 'lp-tools-clinic-xl.webp',
      xl: 'lp-tools-clinic-xl.webp',
    },
    accordions: [
      {
        title:
          'Calcule de maneira rápida e precisa o valor ideal dos seus serviços, assegurando uma remuneração justa e transparente',
        cards: [
          {
            id: 12,
            title: 'Calculadora de Honorários Médicos',
            images: {
              xs: 'lp-tools-honorary-calculator-xl.webp',
              sm: 'lp-tools-honorary-calculator-xl.webp',
              md: 'lp-tools-honorary-calculator-xl.webp',
              lg: 'lp-tools-honorary-calculator-xl.webp',
              xl: 'lp-tools-honorary-calculator-xl.webp',
            },
            description: 'Calcule e gerencie seus honorários médicos, sem precisar de planilhas ou papel.',
          },
        ],
      },
      {
        title:
          'Defina as melhores condutas, faça diagnósticos com segurança e calcule doses de medicamentos com agilidade',
        cards: [
          {
            id: 13,
            title: 'Calculadoras e Escores',
            images: {
              xs: 'lp-tools-scores-and-calculators-xl.webp',
              sm: 'lp-tools-scores-and-calculators-xl.webp',
              md: 'lp-tools-scores-and-calculators-xl.webp',
              lg: 'lp-tools-scores-and-calculators-xl.webp',
              xl: 'lp-tools-scores-and-calculators-xl.webp',
            },
            description:
              'Faça cálculos essenciais para diagnóstico, tratamento e prognóstico de condições clínicas de forma ágil e segura.',
          },
        ],
      },
    ],
  },
];
